<template>
	<transition name="fade">
		<div v-if="isVisible" class="free-delivery-bar text-center">{{ freeDeliveryText }}</div>
	</transition>
</template>

<script>
import city from "@/mixins/city";
import freeDelivery from "@/mixins/free-delivery";

/**
 * Плавающая плашка внизу экрана с сообщением о бесплатной доставке (см. mixins/free-delivery.js).
 * Показывается после выбора зоны доставки и скрывается, когда пользователь долистал до нижнего блока
 * с ценами (.basket-form-cost) - там эта информация уже есть.
 */
export default {
	name: "free-delivery-bar",
	mixins: [city, freeDelivery],
	props: {
		form: {},
	},
	data() {
		return {
			isCostBlockReached: false,
			isCheckScheduled: false,
		}
	},
	computed: {
		isVisible() {
			return !!this.freeDeliveryText && !this.isCostBlockReached;
		},
	},
	watch: {
		freeDeliveryText() {
			// нижний блок цен может появиться в DOM только после выбора зоны
			this.$nextTick(this.checkCostBlock);
		},
	},
	methods: {
		checkCostBlock() {
			const block = document.querySelector('.basket-form-cost');
			this.isCostBlockReached = !!block && block.getBoundingClientRect().top < window.innerHeight;
		},
		onScrollOrResize() {
			if (this.isCheckScheduled) return;
			this.isCheckScheduled = true;
			requestAnimationFrame(() => {
				this.isCheckScheduled = false;
				this.checkCostBlock();
			});
		},
	},
	mounted() {
		window.addEventListener('scroll', this.onScrollOrResize, {passive: true});
		window.addEventListener('resize', this.onScrollOrResize);
		this.checkCostBlock();
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.onScrollOrResize);
		window.removeEventListener('resize', this.onScrollOrResize);
	},
}
</script>

<style lang="scss">
.free-delivery-bar {
	position: fixed;
	right: 0;
	bottom: 0;
	left: 0;
	padding: 8px 15px;
	background: $golden;
	color: $white;
	font-size: 13px;
	line-height: 1.3;
	z-index: 40;

	@include up($md) {
		font-size: 16px;
	}
}
</style>
